import React, { useState } from "react";

import { SpaceBetween, ContentLayout, Header, Alert, Tabs } from "@amzn/awsui-components-console";
import DocumentManagerWrapper from "./DocumentManagerWrapper";
import {
  AUTHORIZATION_FORM_DOCUMENT_TYPE,
  WC_CANADA_PROVINCE_FORM_DOCUMENT_TYPE,
  MEDICAL_PANEL_DOCUMENT_TYPE,
  STATE_FORM_DOCUMENT_TYPE,
} from "src/views/workersCompensationDocuments/constants";

const DocumentsManagement = () => {
  const [activeTabId, setActiveTabId] = useState("us");

  return (
    <ContentLayout maxContentWidth={1000} header={<Header>Admin Documents Management Page</Header>}>
      <SpaceBetween size="s" direction="vertical">
        <Alert type="warning">
          Files uploaded through document management are automatically scanned for malware. Files
          identified as potential malware will be automatically deleted and will no longer be
          available.
        </Alert>
        <Tabs
          activeTabId={activeTabId}
          onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
          tabs={[
            {
              id: "us",
              label: "United States",
              content: (
                <SpaceBetween size="s" direction="vertical">
                  <DocumentManagerWrapper
                    title="Preferred Medical Providers"
                    documentType={MEDICAL_PANEL_DOCUMENT_TYPE}
                    description="Select a Medical Panel file to download or delete"
                  />
                  <DocumentManagerWrapper
                    title="Authorization for Medical Evaluation and Prescription Card"
                    documentType={AUTHORIZATION_FORM_DOCUMENT_TYPE}
                    description="Select an Authorization form to download or delete"
                  />
                  <DocumentManagerWrapper
                    title="State Forms"
                    documentType={STATE_FORM_DOCUMENT_TYPE}
                    description="Select a State form to download or delete"
                  />
                </SpaceBetween>
              ),
            },
            {
              id: "canada",
              label: "Canada",
              content: (
                <SpaceBetween size="s" direction="vertical">
                  <DocumentManagerWrapper
                    title="Province Forms"
                    documentType={WC_CANADA_PROVINCE_FORM_DOCUMENT_TYPE}
                    description="Select a Province form to download or delete"
                  />
                </SpaceBetween>
              ),
            },
          ]}
        />
      </SpaceBetween>
    </ContentLayout>
  );
};
export default DocumentsManagement;
